import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function BulkCardsModal({ players, club, catName, onClose }) {
  const logoUrl = club?.logo_file_id ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${club.logo_file_id}` : null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="bulk-cards-modal">
      <div className="absolute inset-0 bg-black/50 print:hidden" onClick={onClose} />
      <div className="relative max-h-[85vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-white p-4 shadow-2xl">
        <div className="mb-3 flex items-center justify-between print:hidden">
          <h3 className="text-sm font-bold text-slate-800">طباعة بطاقات اللاعبين ({players.length})</h3>
          <div className="flex gap-2">
            <button onClick={() => window.print()} className="rounded-lg bg-[#16233b] px-4 py-2 text-sm font-semibold text-white" data-testid="bulk-cards-print-btn">طباعة</button>
            <button onClick={onClose} className="rounded-lg border border-slate-300 px-4 py-2 text-sm text-slate-600" data-testid="bulk-cards-close-btn">إغلاق</button>
          </div>
        </div>
        <div className="bulk-cards-print-area grid grid-cols-1 gap-4 sm:grid-cols-2">
          {players.map((p) => (
            <div key={p.id} className="bulk-card overflow-hidden rounded-xl border border-slate-200">
              <div className="flex items-center gap-2 bg-[#16233b] px-3 py-2">
                {logoUrl && <img src={logoUrl} alt="" className="h-8 w-8 rounded bg-white/10 object-cover" />}
                <span className="text-xs font-bold text-white">{club?.name || club?.club_name || 'المنشأة الرياضية'}</span>
              </div>
              <div className="flex items-center gap-3 px-3 py-3">
                {p.photo_url ? <img src={p.photo_url} alt="" className="h-14 w-14 rounded-full bg-slate-100 object-cover" /> : <div className="flex h-14 w-14 items-center justify-center rounded-full bg-slate-100 text-sm font-bold text-[#16233b]">{(p.name || '؟').slice(0, 2)}</div>}
                <div className="min-w-0 text-sm">
                  <div className="truncate font-bold text-slate-900">{p.name}</div>
                  <div className="text-xs text-slate-500">{catName(p.category_id)} · رقم {p.jersey_number ?? '—'}</div>
                </div>
                <QRCodeSVG value={p.id} size={56} level="M" className="mr-auto shrink-0" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          .bulk-cards-print-area, .bulk-cards-print-area * { visibility: visible !important; }
          .bulk-cards-print-area { position: fixed; top: 10px; right: 10px; left: 10px; }
          .bulk-card { break-inside: avoid; }
        }
      `}</style>
    </div>
  );
}
